import { JsonValue } from "@bufbuild/protobuf";
import { useQuery } from "@tanstack/react-query";

import { ListScmConfigResponse } from "@protos/scm/v1/scm";
import { authGet } from "@shared/api";

import { useOrg } from "../useOrg";

const getDeploymentScmConfigs = async (
  deploymentId: number
): Promise<ListScmConfigResponse> =>
  authGet<JsonValue>(`/api/scm/deployments/${deploymentId}/configs`).then(
    (jsonResp) => {
      return ListScmConfigResponse.fromJSON(jsonResp);
    }
  );

/**
 * Get the current deployments SCM configs.
 *
 * @returns a query that returns the current deployments SCM configs
 */
export const useScmConfigList = () => {
  const [org] = useOrg();
  const deploymentId = org?.id;

  return useQuery({
    queryKey: ["deploymentScmConfigs", deploymentId],

    queryFn: async () => {
      const response = await getDeploymentScmConfigs(deploymentId!);
      return response.configs.sort((a, b) => a.id - b.id);
    },
    // Only enable the query if we have an org as this hook can be called before
    // the org is fully loaded following a redirect from GitHub on the SetupGitHubInstall
    // component of onboarding at /onboarding/scm/github
    enabled: !!deploymentId,
    // don't refetch if we loaded the cache before rendering (e.g. in useRootGroupIds)
    staleTime: 1000,
  });
};
